import React, { Component } from 'react'
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { clientname, currentTenant, dataaccess, financialyearend, financialyearstart, logo, thousandsdisplay, userid, currency } from "../../Common/Credentials";
import { spin } from "../../Common/NewLoader";
import { purchaseid } from "../../Common/Permissions";
import PurchaseServices from "../PurchseServices";
import { NumericFormat } from 'react-number-format';
import { FormControlLabel, Grid, Tooltip, TextField, MenuItem } from "@mui/material";
import IOSSwitch from "../../CommonComponents/IOSSwitch.js";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import UpArrow from "../../images/Icons/up-arrow.png";
import ViewIcon from "../../images/Icons/preview.png";
import EditIcon from "../../images/Icons/edit.png";

// Import CSS
import '../../NewUI/NewUI.css';
import Footer from '../../Component/Footer.js';
import Header from '../../Component/Header.js';
import Menu from '../../Component/Menu.js';

const TabButton = ({ active, onClick, children }) => (
  <fieldset
    onClick={onClick}
    className={`UI-tab-button ${active ? "UI-active-tab" : "UI-inactive-tab"}`}
    style={{
      cursor: "pointer",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      padding: "8px 16px",
      fontSize: "0.8rem",
      fontWeight: 500,
      textWrap: "nowrap",
    }}
  >
    {children}
    <img
      src={UpArrow}
      alt="Up Arrow"
      className="UI-tab-arrow"
      style={{
        transform: active ? "rotate(30deg)" : "rotate(0deg)",
      }}
    />
  </fieldset>
);

class Purchase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      podata: [],
      completedpo: [],
      cancelledpo: [],
      pendingpoitems: [],
      completedpoitems: [],
      pendingbyitem: true,
      compbyitem: false,
      po: true,
      comp: false,
      canl: false,
      type: "Purchases By Order",
      fromdate: moment().subtract(7, "days"),
      todate: moment(),
      dateFilterApplied: false,

      // UI State
      isMobile: window.innerWidth <= 768,
      currentView: 'list',
      selectedPurchase: null,
      searchTerm: "",
      showSearch: false,
      hovered: null,
      hoveredRow: null,
      isActionHovered: null,
      filteredData: [],
      filteredSidebarData: [],
      currentPage: 1,
      itemsPerPage: 20,
      hasScrolledToSelected: false,
      sortConfig: { key: 'supplier', direction: 'asc' },
      initialLoad: true,
      exportDropdownOpen: false
    };

    this.handleResize = this.handleResize.bind(this);
    this.refreshPurchase = this.refreshPurchase.bind(this);
    this.handlepoChange = this.handlepoChange.bind(this);
    this.handlecompChange = this.handlecompChange.bind(this);
    this.handlecanlChange = this.handlecanlChange.bind(this);
    this.handlePendingChangeByitem = this.handlePendingChangeByitem.bind(this);
    this.handlecompChangeByitem = this.handlecompChangeByitem.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.handleDateFilter = this.handleDateFilter.bind(this);
    this.handlePreviousMonth = this.handlePreviousMonth.bind(this);
    this.handleClearFilter = this.handleClearFilter.bind(this);
    this.exportPDF = this.exportPDF.bind(this);
    this.toggleExportDropdown = this.toggleExportDropdown.bind(this);
    this.closeExportDropdown = this.closeExportDropdown.bind(this);
    this.handlePurchaseClick = this.handlePurchaseClick.bind(this);
    this.handleBackToList = this.handleBackToList.bind(this);
    this.renderTable = this.renderTable.bind(this);
    this.renderTypeTabs = this.renderTypeTabs.bind(this);
    this.renderStatusTabs = this.renderStatusTabs.bind(this);
    this.renderListView = this.renderListView.bind(this);
    this.renderDetailView = this.renderDetailView.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleItemsPerPageChange = this.handleItemsPerPageChange.bind(this);
    this.renderPagination = this.renderPagination.bind(this);
    this.sortData = this.sortData.bind(this);
    this.getSortedData = this.getSortedData.bind(this);
    this.formatCurrency = this.formatCurrency.bind(this);
    this.highlightSearchText = this.highlightSearchText.bind(this);
    this.escapeRegex = this.escapeRegex.bind(this);
    this.getCurrentData = this.getCurrentData.bind(this);
    this.updateFilteredData = this.updateFilteredData.bind(this);
    this.sidebarRef = React.createRef();
    this.scrollTimeout = null;
    this.exportRef = React.createRef();
  }

  // Sort indicator component
  SortIndicator = ({ columnKey }) => {
    if (this.state.sortConfig.key !== columnKey) {
      return <i className="fa fa-sort UI-sort-icon" />;
    }
    return this.state.sortConfig.direction === 'asc'
      ? <i className="fa fa-sort-up UI-sort-icon UI-sort-active" />
      : <i className="fa fa-sort-down UI-sort-icon UI-sort-active" />;
  }

  // Sorting function
  sortData(key) {
    let direction = 'asc';
    if (this.state.sortConfig.key === key && this.state.sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    this.setState({ sortConfig: { key, direction } });
  }

  getSortedData(data) {
    if (!this.state.sortConfig.key) return data;

    return [...data].sort((a, b) => {
      let aValue, bValue;

      switch (this.state.sortConfig.key) {
        case 'supplier':
          aValue = a.supplier || '';
          bValue = b.supplier || '';
          break;
        case 'custompoid':
          aValue = a.custompoid || '';
          bValue = b.custompoid || '';
          break;
        case 'createdAt':
          aValue = new Date(a.createdAt).getTime();
          bValue = new Date(b.createdAt).getTime();
          break;
        case 'pototal':
          aValue = Number(a.pototal) || 0;
          bValue = Number(b.pototal) || 0;
          break;
        case 'balance':
          aValue = Number(a.balance) || 0;
          bValue = Number(b.balance) || 0;
          break;
        default:
          aValue = a[this.state.sortConfig.key] || '';
          bValue = b[this.state.sortConfig.key] || '';
      }

      if (aValue < bValue) {
        return this.state.sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return this.state.sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  escapeRegex(string) {
    if (!string) return '';
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlightSearchText(text, searchTerm) {
    if (!searchTerm?.trim() || !text) return text;

    const rawText = String(text);
    const escapedSearchTerm = this.escapeRegex(searchTerm);

    if (escapedSearchTerm.length > 50) {
      return rawText;
    }

    try {
      const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
      const parts = rawText.split(regex);

      return parts.map((part, index) =>
        regex.test(part)
          ? React.createElement('mark', {
            key: index,
            className: 'UI-search-highlight'
          }, part)
          : part
      );
    } catch (error) {
      console.warn('Regex error in search:', error);
      return rawText;
    }
  }

  formatCurrency(value) {
    if (value === null || value === undefined) return '0';
    const numericValue = typeof value === 'object' && value.parsedValue !== undefined ? value.parsedValue : value;

    const prefix = currency === "INR" ? "₹ " : currency === "USD" ? "$ " : currency + " ";

    return (
      <NumericFormat
        displayType="text"
        value={numericValue}
        decimalScale={2}
        fixedDecimalScale={true}
        thousandSeparator={true}
        thousandsGroupStyle={thousandsdisplay}
        prefix={prefix.trim()}
      />
    );
  }

  formatCurrencyAsString(value) {
    if (value === null || value === undefined) return '0.00';
    const numericValue = typeof value === 'object' && value.parsedValue !== undefined ? value.parsedValue : value;

    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericValue);
  }

  formatCurrencyWithConversion(amount, ccamount, invCurrency, convRate, mainCurrency, color, searchTerm) {
    const numAmount = Number(amount || 0);
    const conversionRate = Number(convRate || 1);

    const mainPrefix = mainCurrency === 'INR' ? '₹ ' : mainCurrency === 'USD' ? '$ ' : mainCurrency + ' ';
    const formattedMain = `${mainPrefix}${numAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

    const convertedAmount = ccamount ? ccamount : numAmount * conversionRate;
    const invPrefix = invCurrency === 'INR' ? '₹ ' : invCurrency === 'USD' ? '$ ' : invCurrency + ' ';
    const formattedConverted = `${invPrefix}${convertedAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

    if (mainCurrency !== invCurrency && numAmount > 0) {
      return (
        <div style={{ textAlign: 'right', color }}>
          <div>{this.highlightSearchText(formattedMain, searchTerm)}</div>
          <div style={{ fontSize: '0.72rem', color: '#888' }}>
            {this.highlightSearchText(formattedConverted, searchTerm)}
          </div>
        </div>
      );
    }

    return (
      <span style={{ color }}>
        {this.highlightSearchText(formattedMain, searchTerm)}
      </span>
    );
  }

  handleResize() {
    const isMobile = window.innerWidth <= 768;
    this.setState({ isMobile });
    if (!isMobile) {
      this.setState({ showSearch: false });
    }
  }

  componentDidMount() {
    if (window.innerWidth <= 768) {
      this.setState({ showSearch: true });
    }
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mousedown', this.handleClickOutside);

    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }
    this.setState({ loading: true });
    this.refreshPurchase();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.currentView === 'detail' &&
      this.state.selectedPurchase &&
      this.sidebarRef.current &&
      !this.state.hasScrolledToSelected) {

      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      this.scrollTimeout = setTimeout(() => {
        const selectedElement = this.sidebarRef.current.querySelector(`[data-purchase-id="${this.state.selectedPurchase.id}"]`);
        if (selectedElement) {
          selectedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.setState({ hasScrolledToSelected: true });
        }
      }, 100);
    }

    if (prevState.currentView !== this.state.currentView && this.state.currentView === 'list') {
      this.setState({ hasScrolledToSelected: false });
    }

    if (prevState.selectedPurchase?.id !== this.state.selectedPurchase?.id) {
      this.setState({ hasScrolledToSelected: false });
    }

    if (prevState.type !== this.state.type ||
      prevState.po !== this.state.po ||
      prevState.comp !== this.state.comp ||
      prevState.canl !== this.state.canl ||
      prevState.pendingbyitem !== this.state.pendingbyitem ||
      prevState.compbyitem !== this.state.compbyitem) {
      this.updateFilteredData();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('mousedown', this.handleClickOutside);
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  }

  handleClickOutside = (event) => {
    if (this.exportRef.current && !this.exportRef.current.contains(event.target)) {
      this.setState({ exportDropdownOpen: false });
    }
  };

  refreshPurchase() {
    let datadao = {
      tenantid: currentTenant,
      startdate: this.state.dateFilterApplied ? this.state.fromdate : financialyearstart,
      enddate: this.state.dateFilterApplied ? this.state.todate : financialyearend,
      userid: userid,
      dataaccess: dataaccess
    }

    if (this.state.initialLoad) {
      this.setState({ initialLoad: false });
    }

    this.setState({ loading: true });

    // Fetch all purchase data
    PurchaseServices.GetAllPurchases(datadao).then((response) => {
      this.setState({
        podata: response.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
          .map(e => Object.assign(e, {
            month: moment(e.createdAt).format("MMMM YYYY"),
            aging: moment().diff(moment(e.createdAt), 'days')
          }))
      }, () => {
        this.updateFilteredData();
      });
    })
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });

    PurchaseServices.GetPObyItems(currentTenant).then(res => {
      this.setState({
        pendingpoitems: res.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1).filter(e => e.pendingquantity !== 0),
        completedpoitems: res.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1).filter(e => e.pendingquantity === 0)
      }, () => {
        this.updateFilteredData();
      });
    });

    // Fetch completed and cancelled PO if date filter is applied or initial load
    if (this.state.dateFilterApplied || this.state.initialLoad) {
      this.refreshCompletedOrCancelledPO();
    }
  }

  refreshCompletedOrCancelledPO() {
    let datadao = {
      tenantid: currentTenant,
      startdate: moment(this.state.fromdate).set({ hour: 0, minute: 0, second: 0, millisecond: 1 }),
      enddate: moment(this.state.todate).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }),
      userid: userid,
      dataaccess: dataaccess
    };

    PurchaseServices.GetCompletedPO(datadao).then(response => {
      this.setState({
        completedpo: response.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
          .map(e => Object.assign(e, { month: moment(e.createdAt).format("MMMM YYYY") }))
      }, () => {
        this.updateFilteredData();
      });
    });

    PurchaseServices.GetCancelledPO(datadao).then(response => {
      this.setState({
        cancelledpo: response.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
      }, () => {
        this.updateFilteredData();
      });
    });
  }

  updateFilteredData() {
    const { searchTerm, type, po, comp, canl, pendingbyitem, compbyitem } = this.state;

    let data = [];
    if (type === "Purchases By Order") {
      if (po) data = this.state.podata;
      else if (comp) data = this.state.completedpo;
      else if (canl) data = this.state.cancelledpo;
    } else {
      if (pendingbyitem) data = this.state.pendingpoitems;
      else if (compbyitem) data = this.state.completedpoitems;
    }

    if (!searchTerm.trim()) {
      this.setState({
        filteredData: data,
        filteredSidebarData: this.state.currentView === 'detail' ? data : data,
        currentPage: 1,
        loading: false
      });
      return;
    }

    const cleanSearch = searchTerm.replace(/[^\w₹$€]/g, '').toLowerCase();

    const filtered = data.filter((item) => {
      const checkFields = [
        item.supplier,
        item.custompoid,
        item.agent,
        item.potype,
        item.postatus,
        item.pototal?.toString(),
        item.balance?.toString(),
      ];

      // For purchases by item, check additional fields
      if (type === "Purchases By Item") {
        checkFields.push(
          item.itemname,
          item.quantity?.toString(),
          item.pendingquantity?.toString()
        );
      }

      return checkFields.some((field) => {
        if (field === undefined || field === null) return false;

        const raw = String(field);
        const cleanField = raw.replace(/[^\w₹$€]/g, '').toLowerCase();

        return (
          cleanField.includes(cleanSearch) ||
          raw.toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
    });

    this.setState({
      filteredData: filtered,
      filteredSidebarData: this.state.currentView === 'detail' ? filtered : data,
      currentPage: 1,
      loading: false
    });
  }

  handlepoChange() {
    this.setState({
      po: true,
      comp: false,
      canl: false,
      currentView: 'list',
      selectedPurchase: null,
      sortConfig: { key: 'supplier', direction: 'asc' }
    });
  }

  handlecompChange() {
    this.setState({
      comp: true,
      po: false,
      canl: false,
      currentView: 'list',
      selectedPurchase: null,
      sortConfig: { key: 'supplier', direction: 'asc' }
    });
  }

  handlecanlChange() {
    this.setState({
      canl: true,
      po: false,
      comp: false,
      currentView: 'list',
      selectedPurchase: null,
      sortConfig: { key: 'supplier', direction: 'asc' }
    });
  }

  handlePendingChangeByitem() {
    this.setState({
      pendingbyitem: true,
      compbyitem: false,
      currentView: 'list',
      selectedPurchase: null,
      sortConfig: { key: 'supplier', direction: 'asc' }
    });
  }

  handlecompChangeByitem() {
    this.setState({
      pendingbyitem: false,
      compbyitem: true,
      currentView: 'list',
      selectedPurchase: null,
      sortConfig: { key: 'supplier', direction: 'asc' }
    });
  }

  handleSearch(term) {
    this.setState({ searchTerm: term }, () => {
      this.updateFilteredData();
    });
  }

  getCurrentData() {
    if (this.state.type === "Purchases By Order") {
      if (this.state.po) return this.state.podata;
      if (this.state.comp) return this.state.completedpo;
      if (this.state.canl) return this.state.cancelledpo;
      return this.state.podata;
    } else {
      if (this.state.pendingbyitem) return this.state.pendingpoitems;
      if (this.state.compbyitem) return this.state.completedpoitems;
      return this.state.pendingpoitems;
    }
  }

  handleFromDateChange = (date) => {
    this.setState({
      fromdate: date,
      todate: moment(date).diff(this.state.todate, "days") >= 0
        ? this.state.todate
        : date,
    });
  };

  handleToDateChange = (date) => {
    this.setState({ todate: date });
  };

  handleDateFilter = () => {
    this.setState({ dateFilterApplied: true }, () => {
      this.refreshCompletedOrCancelledPO();
      this.refreshPurchase()
    });
  };

  handlePreviousMonth = () => {
    const startOfPrevMonth = moment().subtract(1, 'months').startOf('month');
    const endOfPrevMonth = moment().subtract(1, 'months').endOf('month');

    this.setState({
      fromdate: startOfPrevMonth,
      todate: endOfPrevMonth,
      dateFilterApplied: true
    }, () => {
      this.refreshCompletedOrCancelledPO();
    });
  };

  handleClearFilter = () => {
    this.setState({
      fromdate: moment().subtract(7, "days"),
      todate: moment(),
      dateFilterApplied: false
    }, () => {
      this.refreshPurchase();
    });
  };

  getCurrentPageData() {
    const { filteredData, currentPage, itemsPerPage } = this.state;
    const sortedData = this.getSortedData(filteredData);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return sortedData.slice(indexOfFirstItem, indexOfLastItem);
  }

  handlePageChange(newPage) {
    this.setState({ currentPage: newPage });
  }

  handleItemsPerPageChange(e) {
    this.setState({
      itemsPerPage: parseInt(e.target.value),
      currentPage: 1
    });
  }

  handlePurchaseClick(purchase) {
    this.setState({
      selectedPurchase: purchase,
      currentView: 'detail',
      hasScrolledToSelected: false
    }, () => {
      this.setState({
        filteredSidebarData: this.state.filteredData
      });
    });
  }

  handleBackToList() {
    this.setState({
      currentView: 'list',
      selectedPurchase: null,
      hasScrolledToSelected: false
    }, () => {
      this.updateFilteredData();
    });
  }

  getCurrentStatusLabel() {
    const { type, po, comp, canl, pendingbyitem, compbyitem } = this.state;

    if (type === "Purchases By Order") {
      if (po) return "Active Orders";
      if (comp) return "Completed Orders";
      if (canl) return "Cancelled Orders";
    } else {
      if (pendingbyitem) return "Active/Pending Items";
      if (compbyitem) return "Completed Items";
    }
    return "All";
  }

  toggleExportDropdown() {
    this.setState(prevState => ({
      exportDropdownOpen: !prevState.exportDropdownOpen
    }));
  }

  closeExportDropdown() {
    this.setState({ exportDropdownOpen: false });
  }

  exportPDF() {
    this.closeExportDropdown();

    const data = this.getCurrentData();
    const curdate = moment().format('DD-MM-YYYY HH:mm:ss');
    const statusLabel = this.getCurrentStatusLabel();
    const typeLabel = this.state.type;

    // Create PDF
    const doc = new jsPDF('l', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const leftMargin = 15;
    const rightMargin = 10;
    const topMargin = 5;
    const bottomMargin = 10;
    const contentWidth = pageWidth - leftMargin - rightMargin;

    let yPosition = topMargin + 10;

    // Header
    doc.setFontSize(8);
    doc.setFont(undefined, 'bold');
    doc.text(clientname, leftMargin + 5, yPosition, {
      maxWidth: contentWidth * 0.9,
      align: 'left',
      overflow: 'linebreak'
    });

    const companyNameLines = doc.splitTextToSize(clientname, contentWidth * 0.9);
    const companyNameHeight = companyNameLines.length * 5;
    yPosition += companyNameHeight;

    // Document Title
    doc.setFontSize(7.5);
    doc.setFont(undefined, 'normal');
    doc.text(`${typeLabel} - ${statusLabel}`, leftMargin + 5, yPosition);
    yPosition += 4;

    // Date Range
    const dateFilterInfo = this.state.dateFilterApplied
      ? `${moment(this.state.fromdate).format("DD MMM YYYY")} - ${moment(this.state.todate).format("DD MMM YYYY")}`
      : 'All Dates';

    doc.setFontSize(7);
    doc.text(`Date Range: ${dateFilterInfo}`, leftMargin + 5, yPosition);
    yPosition += 4;

    doc.text(`Export Date: ${curdate}`, leftMargin + 5, yPosition);
    yPosition += 5;

    // Define columns based on type
    const columns = [];
    if (this.state.type === "Purchases By Order") {
      columns.push(
        { header: "Supplier", dataKey: 'supplier' },
        { header: "PO ID", dataKey: 'custompoid' },
        { header: "Agent", dataKey: 'agent' },
        { header: "Date", dataKey: 'createdAt' },
        { header: "PO Type", dataKey: 'potype' },
        { header: "Status", dataKey: 'postatus' },
        { header: "Total Amount", dataKey: 'pototal' }
      );

      if (this.state.po) {
        columns.push({ header: "Balance", dataKey: 'balance' });
      }
    } else {
      columns.push(
        { header: "PO ID", dataKey: 'custompoid' },
        { header: "Supplier", dataKey: 'supplier' },
        { header: "Item Name", dataKey: 'itemname' },
        { header: "Total Qty", dataKey: 'quantity' },
        { header: "Pending Qty", dataKey: 'pendingquantity' },
        { header: "Accepted Qty", dataKey: 'acceptedquantity' },
        { header: "Price", dataKey: 'price' },
        { header: "Total (Inc. Tax)", dataKey: 'totalpricewtax' },
        { header: "Status", dataKey: 'postatus' }
      );
    }

    // Prepare table data
    const tableData = data.map(item => {
      const row = {};
      columns.forEach(col => {
        if (col.dataKey === 'createdAt') {
          row[col.dataKey] = moment(item.createdAt).format('DD-MM-YYYY HH:mm');
        } else if (col.dataKey === 'pototal' || col.dataKey === 'balance' || col.dataKey === 'price' || col.dataKey === 'totalpricewtax') {
          row[col.dataKey] = this.formatCurrencyAsString(item[col.dataKey] || 0);
        } else if (col.dataKey === 'agent' && (!item[col.dataKey] || item[col.dataKey] === '')) {
          row[col.dataKey] = 'Direct';
        } else {
          row[col.dataKey] = item[col.dataKey] || '';
        }
      });
      return row;
    });

    // Generate table
    autoTable(doc, {
      startY: yPosition,
      margin: { left: leftMargin, right: rightMargin, top: 10, bottom: bottomMargin },
      tableWidth: contentWidth,
      head: [columns.map(col => col.header)],
      body: tableData.map(item => columns.map(col => String(item[col.dataKey] || ''))),
      theme: 'grid',
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontSize: 7,
        fontStyle: 'bold',
        halign: 'center',
        valign: 'middle',
        cellPadding: 3,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      bodyStyles: {
        fontSize: 6,
        textColor: [0, 0, 0],
        cellPadding: 2,
        valign: 'middle',
        overflow: 'linebreak',
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      didDrawPage: (data) => {
        const footerY = pageHeight - bottomMargin + 5;
        doc.setFontSize(7);
        const pageText = `Page ${data.pageNumber} of ${data.pageCount}`;
        const textWidth = doc.getTextWidth(pageText);
        doc.text(pageText, leftMargin + (contentWidth - textWidth) / 2, footerY);
      },
    });

    const filename = `${clientname}_${typeLabel.replace(/\s+/g, '_')}_${statusLabel.replace(/\s+/g, '_')}_${moment().format('DDMMYYYY_HHmm')}.pdf`;
    doc.save(filename);
  }

  renderTable() {
    const isMobile = this.state.isMobile;
    const currentPageData = this.getCurrentPageData();

    if (this.state.filteredData.length === 0) {
      return (
        <div className={`UI-no-items-message ${isMobile ? 'UI-no-items-message-mobile' : ''}`}>
          {this.state.searchTerm ? 'No purchases found matching your search' : 'No purchases available'}
        </div>
      );
    }

    return (
      <>
        <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
          <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
            <thead className="UI-table-header">
              <tr>
                {this.state.type === "Purchases By Order" ? (
                  <>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'supplier' ? 'UI-th-sorted' : ''}`}
                      onClick={() => this.sortData('supplier')}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="UI-th-content">
                        Supplier
                        <this.SortIndicator columnKey="supplier" />
                      </div>
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'custompoid' ? 'UI-th-sorted' : ''}`}
                      onClick={() => this.sortData('custompoid')}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="UI-th-content">
                        PO ID
                        <this.SortIndicator columnKey="custompoid" />
                      </div>
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      Agent
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdAt' ? 'UI-th-sorted' : ''}`}
                      onClick={() => this.sortData('createdAt')}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="UI-th-content">
                        Date
                        <this.SortIndicator columnKey="createdAt" />
                      </div>
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      PO Type
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      Status
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'pototal' ? 'UI-th-sorted' : ''}`}
                      onClick={() => this.sortData('pototal')}
                      style={{ cursor: 'pointer', textAlign: 'right' }}
                    >
                      <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                        Total Amount
                        <this.SortIndicator columnKey="pototal" />
                      </div>
                    </th>
                    {this.state.po && (
                      <th
                        className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'balance' ? 'UI-th-sorted' : ''}`}
                        onClick={() => this.sortData('balance')}
                        style={{ cursor: 'pointer', textAlign: 'right' }}
                      >
                        <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                          Balance
                          <this.SortIndicator columnKey="balance" />
                        </div>
                      </th>
                    )}
                    <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`} style={{ textAlign: 'center' }}>Actions</th>
                  </>
                ) : (
                  <>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      PO ID
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'supplier' ? 'UI-th-sorted' : ''}`}
                      onClick={() => this.sortData('supplier')}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="UI-th-content">
                        Supplier
                        <this.SortIndicator columnKey="supplier" />
                      </div>
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      Item Name
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      Total Qty
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      Pending Qty
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      Accepted Qty
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                      style={{ textAlign: 'right' }}
                    >
                      Price
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                      style={{ textAlign: 'right' }}
                    >
                      Total (Inc. Tax)
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      Status
                    </th>
                    <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`} style={{ textAlign: 'center' }}>Actions</th>
                  </>
                )}
              </tr>
            </thead>

            <tbody>
              {currentPageData.map((purchase) => (
                <tr
                  key={purchase.id || `${purchase.custompoid}-${purchase.itemname}`}
                  className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${this.state.hoveredRow === purchase.id ? 'UI-table-row-hovered' : ''}`}
                  onClick={() => this.handlePurchaseClick(purchase)}
                  onMouseEnter={() => this.setState({ hoveredRow: purchase.id })}
                  onMouseLeave={() => {
                    this.setState({ hoveredRow: null, isActionHovered: null });
                  }}
                >
                  {this.state.type === "Purchases By Order" ? (
                    <>
                      {/* CUSTOMER NAME (Supplier in Purchase) */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name ${this.state.hoveredRow === purchase.id ? 'UI-item-name-hover' : ''}`}
                      >
                        {(() => {
                          const name = purchase.supplier || "";
                          const lastChar = name.slice(-1);
                          const rest = name.slice(0, -1);

                          return (
                            <>
                              <span>{this.highlightSearchText(rest, this.state.searchTerm)}</span>

                              <Tooltip
                                title="View Details"
                                placement="right"
                                arrow
                                slotProps={{
                                  popper: {
                                    sx: { pointerEvents: 'none' },
                                  },
                                }}
                                open={
                                  !this.state.isMobile &&
                                  this.state.hoveredRow === purchase.id &&
                                  !this.state.isActionHovered
                                }
                              >
                                <span style={{ display: "inline-block" }}>
                                  {this.highlightSearchText(lastChar, this.state.searchTerm)}
                                </span>
                              </Tooltip>
                            </>
                          );
                        })()}
                      </td>

                      {/* INVOICE ID (PO ID in Purchase) */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(purchase.custompoid, this.state.searchTerm)}
                      </td>

                      {/* AGENT */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(purchase.agent || 'Direct', this.state.searchTerm)}
                      </td>

                      {/* CREATED AT */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(
                          moment(purchase.createdAt).format('DD-MM-YYYY HH:mm'),
                          this.state.searchTerm
                        )}
                      </td>

                      {/* PO TYPE */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(purchase.potype, this.state.searchTerm)}
                      </td>

                      {/* STATUS */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        <span className={`UI-status-badge UI-status-${purchase.postatus?.toLowerCase().replace(' ', '-')}`}>
                          {this.highlightSearchText(purchase.postatus, this.state.searchTerm)}
                        </span>
                      </td>

                      {/* TOTAL AMOUNT */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-amount ${this.state.hoveredRow === purchase.id ? 'UI-price-hover' : ''}`}
                        style={{ textAlign: "right" }}
                      >
                        {this.formatCurrencyWithConversion(purchase.pototal,purchase.ccpototal,purchase.currency,purchase.curconversionrate,currency,this.state.hoveredRow === purchase.id ? "red" : '#4d4d4d',"")}
                      </td>

                      {/* BALANCE (only for Active Orders) */}
                      {this.state.po && (
                        <td
                          className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-amount`}
                          style={{ textAlign: "right", color: this.state.hoveredRow === purchase.id ? "red" : "red" }}
                        >
                          {this.formatCurrency(purchase.balance)}
                        </td>
                      )}

                      {/* ACTION BUTTONS */}
                      <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                        <div className="UI-action-buttons">
                          <Link
                            to={{ pathname: "/viewpurchaseorder" }}
                            state={{ id: purchase.id }}
                            className={`UI-action-button ${isMobile ? 'UI-action-button-mobile' : ''} UI-edit-button`}
                            style={{ textDecoration: "none" }}
                            onClick={(e) => e.stopPropagation()}
                            onMouseEnter={() =>
                              this.setState({ isActionHovered: `view-${purchase.id}` })
                            }
                            onMouseLeave={() => this.setState({ isActionHovered: null })}
                          >
                            <Tooltip title="Full Details" arrow slotProps={{
                              popper: {
                                sx: { pointerEvents: 'none' },
                              },
                            }}>
                              <img
                                src={ViewIcon}
                                alt="View"
                                className={`UI-action-icon ${isMobile ? 'UI-action-icon-mobile' : ''} ${this.state.isActionHovered === `view-${purchase.id}` ? 'UI-edit-icon-hover' : ''}`}
                              />
                            </Tooltip>
                          </Link>
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                        {this.highlightSearchText(purchase.custompoid, this.state.searchTerm)}
                      </td>
                      <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name`}>
                        {this.highlightSearchText(purchase.supplier, this.state.searchTerm)}
                      </td>
                      <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                        {this.highlightSearchText(purchase.itemname, this.state.searchTerm)}
                      </td>
                      <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`} style={{ textAlign: 'center' }}>
                        {purchase.quantity}
                      </td>
                      <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`} style={{ textAlign: 'center' }}>
                        {purchase.postatus === "Pending" ? 0 : purchase.pendingquantity}
                      </td>
                      <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`} style={{ textAlign: 'center' }}>
                        {purchase.acceptedquantity}
                      </td>
                      <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-amount`} style={{ textAlign: 'right' }}>
                        {this.formatCurrency(purchase.price)}
                      </td>
                      <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-amount`} style={{ textAlign: 'right' }}>
                        {this.formatCurrency(purchase.totalpricewtax)}
                      </td>
                      <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                        <span className={`UI-status-badge UI-status-${purchase.postatus?.toLowerCase().replace(' ', '-')}`}>
                          {this.highlightSearchText(purchase.postatus, this.state.searchTerm)}
                        </span>
                      </td>
                      <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                        <div className="UI-action-buttons">
                          <Link
                            to={{ pathname: "/viewpurchaseorder" }}
                            state={{ id: purchase.poid }}
                            className={`UI-action-button ${isMobile ? 'UI-action-button-mobile' : ''} UI-edit-button`}
                            style={{ textDecoration: "none" }}
                            onClick={(e) => e.stopPropagation()}
                            onMouseEnter={() => this.setState({ isActionHovered: `view-${purchase.poid}` })}
                            onMouseLeave={() => this.setState({ isActionHovered: null })}
                          >
                            <Tooltip title="Full Details" arrow slotProps={{
                              popper: {
                                sx: { pointerEvents: 'none' },
                              },
                            }}>
                              <img
                                src={ViewIcon}
                                alt="View"
                                className={`UI-action-icon ${isMobile ? 'UI-action-icon-mobile' : ''} ${this.state.isActionHovered === `view-${purchase.poid}` ? 'UI-edit-icon-hover' : ''}`}
                              />
                            </Tooltip>
                          </Link>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {this.renderPagination()}
      </>
    );
  }

  renderTypeTabs() {
    const types = ["Purchases By Order", "Purchases By Item"];

    return (
      <div
        className="UI-tabs-row"
        style={{
          marginBottom: "16px",
          marginTop: "10px",
          marginLeft: "10px",
        }}
      >
        {types.map((tabType) => (
          <TabButton
            key={tabType}
            active={this.state.type === tabType}
            onClick={() =>
              this.setState(
                {
                  type: tabType,
                  po: tabType === "Purchases By Order",
                  pendingbyitem: tabType === "Purchases By Item",
                  comp: false,
                  canl: false,
                  compbyitem: false,
                  currentView: 'list',
                  selectedPurchase: null,
                  sortConfig: { key: 'supplier', direction: 'asc' }
                },
                this.updateFilteredData
              )
            }
          >
            {tabType}
          </TabButton>
        ))}
      </div>
    );
  }

  renderStatusTabs() {
    const isMobile = this.state.isMobile;
    const matchCounts = {
      po: this.state.podata.length,
      comp: this.state.completedpo.length,
      canl: this.state.cancelledpo.length,
      pendingbyitem: this.state.pendingpoitems.length,
      compbyitem: this.state.completedpoitems.length,
    };

    if (this.state.type === "Purchases By Order") {
      const tabs = [
        { key: 'po', label: 'Active Orders', handler: this.handlepoChange, active: this.state.po, count: matchCounts.po },
        { key: 'comp', label: 'Completed Orders', handler: this.handlecompChange, active: this.state.comp, count: matchCounts.comp },
        { key: 'canl', label: 'Cancelled Orders', handler: this.handlecanlChange, active: this.state.canl, count: matchCounts.canl }
      ];

      return (
        <div className="UI-quotation-tabs-container">
          {tabs.map((tab) => (
            <div
              key={tab.key}
              className={`UI-quotation-tab ${tab.active ? 'UI-quotation-active-tab' : ''} ${this.state.hovered === `${tab.key}-tab` ? 'UI-quotation-tab-hovered' : ''}`}
              onClick={tab.handler}
              onMouseEnter={() => this.setState({ hovered: `${tab.key}-tab` })}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              {tab.label}
              {tab.count > 0 && (
                <span className="UI-match-count">{tab.count}</span>
              )}
            </div>
          ))}

          {/* Date Filters for Completed and Cancelled Orders tabs - NEW DESIGN */}
          {/* {(this.state.comp || this.state.canl) && ( */}
            <div className="UI-date-filter-container" style={{ marginLeft: 'auto' }}>
              {/* LEFT SIDE: Clear button and Prev Month button */}
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                {/* MIDDLE: Selected date range display (only when filter is applied) */}
                {this.state.dateFilterApplied && (
                  <div className={`UI-selected-date-range ${isMobile ? 'UI-selected-date-range-mobile' : ''}`}>
                    <i className="fa fa-calendar-check" style={{ fontSize: '0.7rem', marginRight: '4px', color: '#4f46e5' }} />
                    {moment(this.state.fromdate).format("DD MMM YYYY")} - {moment(this.state.todate).format("DD MMM YYYY")}
                    <button
                      className="UI-date-range-close"
                      onClick={this.handleClearFilter}
                      onMouseEnter={() => this.setState({ hovered: 'dateRangeClose' })}
                      onMouseLeave={() => this.setState({ hovered: null })}
                      aria-label="Clear date filter"
                    >
                      <i className="fa fa-times" style={{ fontSize: '0.7rem' }} />
                    </button>
                  </div>
                )}

                <button
                  className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${this.state.hovered === "prevMonth" ? 'UI-btn-outline-hover' : ''}`}
                  onClick={this.handlePreviousMonth}
                  onMouseEnter={() => this.setState({ hovered: 'prevMonth' })}
                  onMouseLeave={() => this.setState({ hovered: null })}
                >
                  <i className="fa fa-calendar" style={{ fontSize: '0.7rem' }} />
                  Prev Month
                </button>
              </div>

              {/* RIGHT SIDE: Date pickers and Apply button */}
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <DatePicker
                      label="From Date"
                      value={this.state.fromdate}
                      onChange={this.handleFromDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          size="small"
                          style={{ width: '140px' }}
                        />
                      )}
                    />
                    <span style={{ color: '#64748b', fontSize: '0.8rem' }}>to</span>
                    <DatePicker
                      label="To Date"
                      value={this.state.todate}
                      onChange={this.handleToDateChange}
                      minDate={this.state.fromdate}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          size="small"
                          style={{ width: '140px' }}
                        />
                      )}
                    />
                  </div>
                </LocalizationProvider>
                <button
                  className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${this.state.hovered === "apply" ? 'UI-btn-outline-hover' : ''}`}
                  onClick={this.handleDateFilter}
                  onMouseEnter={() => this.setState({ hovered: 'apply' })}
                  onMouseLeave={() => this.setState({ hovered: null })}
                >
                  <i className="fa fa-filter" style={{ fontSize: '0.7rem' }} />
                  Apply
                </button>
              </div>
            </div>
           {/* )} */}
        </div>
      );
    } else {
      const tabs = [
        { key: 'pendingbyitem', label: 'Active/Pending', handler: this.handlePendingChangeByitem, active: this.state.pendingbyitem, count: matchCounts.pendingbyitem },
        { key: 'compbyitem', label: 'Completed', handler: this.handlecompChangeByitem, active: this.state.compbyitem, count: matchCounts.compbyitem }
      ];

      return (
        <div className="UI-quotation-tabs-container">
          {tabs.map((tab) => (
            <div
              key={tab.key}
              className={`UI-quotation-tab ${tab.active ? 'UI-quotation-active-tab' : ''} ${this.state.hovered === `${tab.key}-tab` ? 'UI-quotation-tab-hovered' : ''}`}
              onClick={tab.handler}
              onMouseEnter={() => this.setState({ hovered: `${tab.key}-tab` })}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              {tab.label}
              {tab.count > 0 && (
                <span className="UI-match-count">{tab.count}</span>
              )}
            </div>
          ))}
        </div>
      );
    }
  }

  renderPagination() {
    const { filteredData, currentPage, itemsPerPage, isMobile } = this.state;

    if (filteredData.length <= itemsPerPage) return null;

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    return (
      <div className={`UI-pagination-container ${isMobile ? 'UI-pagination-container-mobile' : ''}`}>
        <div className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
          Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, filteredData.length)} of {filteredData.length} purchases
        </div>
        <div className={`UI-pagination-controls ${isMobile ? 'UI-pagination-controls-mobile' : ''}`}>
          <TextField
            select
            value={itemsPerPage}
            onChange={this.handleItemsPerPageChange}
            variant="outlined"
            size="small"
            className={`UI-page-size-select ${isMobile ? 'UI-page-size-select-mobile' : ''} ${this.state.hovered === 'pagesize' ? 'UI-page-size-select-hover' : ''}`}
            onMouseEnter={() => this.setState({ hovered: 'pagesize' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            <MenuItem value={5}>5 per page</MenuItem>
            <MenuItem value={10}>10 per page</MenuItem>
            <MenuItem value={20}>20 per page</MenuItem>
            <MenuItem value={50}>50 per page</MenuItem>
          </TextField>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'first' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'first' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'First' : 'First'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'prev' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'prev' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Prev' : 'Previous'}
          </button>

          <span className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
            Page {currentPage} of {totalPages}
          </span>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'next' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'next' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Next' : 'Next'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'last' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'last' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Last' : 'Last'}
          </button>
        </div>
      </div>
    );
  }

  renderDetailView() {
    const { selectedPurchase, filteredSidebarData } = this.state;
    if (!selectedPurchase) return null;

    const isByOrder = this.state.type === "Purchases By Order";

    return (
      <div className="UI-detail-view">
        {/* Sidebar */}
        <div className="UI-sidebar">
          <div className="UI-sidebar-header">
            <button
              className={`UI-back-button ${this.state.hovered === 'back' ? 'UI-back-button-hover' : ''}`}
              onClick={this.handleBackToList}
              onMouseEnter={() => this.setState({ hovered: 'back' })}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              <i className="fa fa-arrow-left" /> Back
            </button>
          </div>
          <div className="UI-sidebar-list" ref={this.sidebarRef}>
            {filteredSidebarData.map((purchase) => (
              <div
                key={purchase.id || `${purchase.custompoid}-${purchase.itemname}`}
                data-purchase-id={purchase.id || purchase.poid}
                className={`UI-sidebar-item ${selectedPurchase.id === purchase.id ? 'UI-sidebar-item-active' : ''} ${this.state.hovered === purchase.id ? 'UI-sidebar-item-hover' : ''}`}
                onClick={() => this.setState({ selectedPurchase: purchase })}
                onMouseEnter={() => this.setState({ hovered: purchase.id })}
                onMouseLeave={() => this.setState({ hovered: null })}
              >
                <div className={`UI-sidebar-item-name ${this.state.hovered === purchase.id ? 'UI-sidebar-item-name-hover' : ''}`}>
                  {isByOrder ? purchase.supplier : purchase.itemname}
                </div>
                <div className={`UI-sidebar-item-code ${this.state.hovered === purchase.id ? 'UI-sidebar-item-code-hover' : ''}`}>
                  {purchase.custompoid}
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Detail Content */}
        <div className="UI-detail-content">
          <div className="UI-detail-header">
            <div className="UI-detail-title-wrapper">
              <h2 className="UI-detail-title">
                {isByOrder ? selectedPurchase.supplier : selectedPurchase.itemname}
              </h2>
              <p className="UI-detail-subtitle">
                PO ID: {selectedPurchase.custompoid}
              </p>
            </div>
            <div className="UI-detail-actions">
              <Link
                to={{ pathname: "/viewpurchaseorder" }}
                state={{ id: selectedPurchase.id || selectedPurchase.poid }}
                className={`UI-detail-action-button UI-detail-edit-button ${this.state.hovered === "view" ? 'UI-edit-button-hover' : ''}`}
                style={{ textDecoration: "none" }}
                onMouseEnter={() => this.setState({ hovered: "view" })}
                onMouseLeave={() => this.setState({ hovered: null })}
              >
                <Tooltip title="View Full Details" arrow slotProps={{
                  popper: {
                    sx: { pointerEvents: 'none' },
                  },
                }}>
                  <img
                    src={ViewIcon}
                    alt="View"
                    className={`UI-action-icon ${this.state.hovered === "view" ? 'UI-action-icon-hover' : ''}`}
                  />
                </Tooltip>
              </Link>
            </div>
          </div>
          <div className="UI-detail-grid">
            {/* Basic Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Basic Information</h3>
              {isByOrder ? (
                <>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Supplier</span>
                    <span className="UI-detail-value">{selectedPurchase.supplier}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">PO ID</span>
                    <span className="UI-detail-value">{selectedPurchase.custompoid}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Agent</span>
                    <span className="UI-detail-value">{selectedPurchase.agent || 'Direct'}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Created Date</span>
                    <span className="UI-detail-value">
                      {moment(selectedPurchase.createdAt).format("DD-MM-YYYY HH:mm")}
                    </span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">PO Type</span>
                    <span className="UI-detail-value">{selectedPurchase.potype}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">PO Status</span>
                    <span className="UI-detail-value">
                      <span className={`UI-status-badge UI-status-${selectedPurchase.postatus?.toLowerCase().replace(' ', '-')}`}>
                        {selectedPurchase.postatus}
                      </span>
                    </span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Created By</span>
                    <span className="UI-detail-value">{selectedPurchase.createdbyname}</span>
                  </div>
                </>
              ) : (
                <>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Item Name</span>
                    <span className="UI-detail-value">{selectedPurchase.itemname}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Supplier</span>
                    <span className="UI-detail-value">{selectedPurchase.supplier}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">PO ID</span>
                    <span className="UI-detail-value">{selectedPurchase.custompoid}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">UOM</span>
                    <span className="UI-detail-value">{selectedPurchase.uom}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Created Date</span>
                    <span className="UI-detail-value">
                      {moment(selectedPurchase.createdAt).format("DD-MM-YYYY HH:mm")}
                    </span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Status</span>
                    <span className="UI-detail-value">
                      <span className={`UI-status-badge UI-status-${selectedPurchase.postatus?.toLowerCase().replace(' ', '-')}`}>
                        {selectedPurchase.postatus}
                      </span>
                    </span>
                  </div>
                </>
              )}
            </div>

            {/* Quantity Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">
                {isByOrder ? 'Financial Information' : 'Quantity Information'}
              </h3>
              {isByOrder ? (
                <>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Total Amount</span>
                    <span className="UI-detail-value">{this.formatCurrencyWithConversion(selectedPurchase.pototal,selectedPurchase.ccpototal,selectedPurchase.currency,selectedPurchase.curconversionrate,currency,'#4d4d4d',"")}</span>
                  </div>
                  {this.state.po && selectedPurchase.balance && (
                    <div className="UI-detail-row">
                      <span className="UI-detail-label">Balance</span>
                      <span className="UI-detail-value" style={{ color: 'red' }}>
                        {this.formatCurrency(selectedPurchase.balance)}
                      </span>
                    </div>
                  )}
                  {selectedPurchase.potaxamount && (
                    <div className="UI-detail-row">
                      <span className="UI-detail-label">Tax Amount</span>
                      <span className="UI-detail-value">{this.formatCurrency(selectedPurchase.potaxamount)}</span>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Total Quantity</span>
                    <span className="UI-detail-value">{selectedPurchase.quantity}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Pending Quantity</span>
                    <span className="UI-detail-value">
                      {selectedPurchase.postatus === "Pending" ? 0 : selectedPurchase.pendingquantity}
                    </span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Accepted Quantity</span>
                    <span className="UI-detail-value">{selectedPurchase.acceptedquantity}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Adjusted Quantity</span>
                    <span className="UI-detail-value">{selectedPurchase.adjustedquantity || 0}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Price</span>
                    <span className="UI-detail-value">{this.formatCurrency(selectedPurchase.price)}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Total (Inc. Tax)</span>
                    <span className="UI-detail-value">{this.formatCurrency(selectedPurchase.totalpricewtax)}</span>
                  </div>
                </>
              )}
            </div>

            {/* Additional Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Additional Information</h3>
              {isByOrder && selectedPurchase.aging !== undefined && (
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Aging (in Days)</span>
                  <span className="UI-detail-value">{selectedPurchase.aging || moment().diff(moment(selectedPurchase.createdAt), 'days')} Days</span>
                </div>
              )}
              {isByOrder && selectedPurchase.month && (
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Month</span>
                  <span className="UI-detail-value">{selectedPurchase.month}</span>
                </div>
              )}
              {!isByOrder && selectedPurchase.agent && (
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Agent</span>
                  <span className="UI-detail-value">{selectedPurchase.agent || 'Direct'}</span>
                </div>
              )}
              {!isByOrder && selectedPurchase.preclosedquantity !== undefined && (
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Preclosed Quantity</span>
                  <span className="UI-detail-value">{selectedPurchase.preclosedquantity || 0}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderListView() {
    return (
      <>
        {this.renderTypeTabs()}
        {this.renderStatusTabs()}
        {this.renderTable()}
      </>
    );
  }

  render() {
    const isMobile = this.state.isMobile;

    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className={`UI-container ${isMobile ? 'UI-container-mobile' : ''}`}>
            <div className="UI-card">
              {/* Header */}
              <div className={`UI-header ${isMobile ? 'UI-header-mobile' : ''}`}>
                <nav className={`UI-breadcrumb ${isMobile ? 'UI-breadcrumb-mobile' : ''}`}>
                  <Link
                    to="/purchase"
                    className={`UI-breadcrumb-item ${this.state.hovered === 'home' ? 'UI-breadcrumb-item-hover' : ''}`}
                    onMouseEnter={() => this.setState({ hovered: 'home' })}
                    onMouseLeave={() => this.setState({ hovered: null })}
                  >
                    Home
                  </Link>
                  <span>/</span>
                  <span className={`UI-breadcrumb-item UI-breadcrumb-active`}>
                    Purchase Orders
                  </span>
                </nav>
                <div className={`UI-header-content ${isMobile ? 'UI-header-content-mobile' : ''}`}>
                  <div>
                    <h1 className={`UI-title ${isMobile ? 'UI-title-mobile' : ''}`}>Purchase Orders</h1>
                    <p className={`UI-subtitle ${isMobile ? 'UI-subtitle-mobile' : ''}`}>
                      {this.state.currentView === 'detail' && this.state.selectedPurchase
                        ? `ID: ${this.state.selectedPurchase.custompoid}`
                        : 'Manage your purchase orders and track deliveries'
                      }
                    </p>
                  </div>
                  <div className={`UI-header-actions ${isMobile ? 'UI-header-actions-mobile' : ''}`}>
                    {/* Desktop Search */}
                    {!isMobile && (
                      <div
                        className={`UI-search-container ${this.state.showSearch ? 'UI-search-container-expanded' : ''} ${this.state.hovered === "search" ? 'UI-search-container-hover' : ''}`}
                        onClick={() => {
                          if (!this.state.showSearch) this.setState({ showSearch: true });
                        }}
                        onMouseEnter={() => this.setState({ hovered: "search" })}
                        onMouseLeave={() => this.setState({ hovered: null })}
                      >
                        <i className={`fa fa-search UI-search-icon ${this.state.hovered === "search" ? 'UI-search-container-hover' : ''}`} />
                        {!this.state.showSearch && "Search"}
                        {this.state.showSearch && (
                          <input
                            type="text"
                            className="UI-search-input"
                            placeholder="Search purchases..."
                            value={this.state.searchTerm}
                            onChange={(e) => this.handleSearch(e.target.value)}
                            autoFocus
                            onClick={(e) => e.stopPropagation()}
                            onBlur={() => {
                              if (this.state.searchTerm.trim() === "") {
                                this.setState({ showSearch: false });
                              }
                            }}
                          />
                        )}
                      </div>
                    )}
                    {/* Mobile Search */}
                    {isMobile && (
                      <input
                        type="text"
                        className="UI-mobile-search-input"
                        placeholder="Search purchases..."
                        value={this.state.searchTerm}
                        onChange={(e) => this.handleSearch(e.target.value)}
                      />
                    )}
                    {/* Export dropdown */}
                    {(purchaseid === '2' || purchaseid === '3') && (
                      <div className="UI-export-container" ref={this.exportRef}>
                        <button
                          className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${this.state.hovered === "export" ? 'UI-btn-outline-hover' : ''}`}
                          onClick={this.toggleExportDropdown}
                          onMouseEnter={() => this.setState({ hovered: "export" })}
                          onMouseLeave={() => this.setState({ hovered: null })}
                        >
                          <i className="fa fa-file-export" /> {isMobile ? "Export" : "Export"}
                          <i className="fa fa-caret-down" style={{ marginLeft: '4px' }} />
                        </button>
                        {this.state.exportDropdownOpen && (
                          <div className="UI-export-dropdown">
                            <button
                              className="UI-export-option"
                              onClick={this.exportPDF}
                              onMouseEnter={() => this.setState({ hovered: "exportPDF" })}
                              onMouseLeave={() => this.setState({ hovered: null })}
                            >
                              <i className="fa fa-file-pdf" /> PDF Export
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                    {/* New Purchase Order button */}
                    {(purchaseid === '2' || purchaseid === '3') && (
                      <Link
                        to={{ pathname: "/newpurchase" }}
                        state={{ id: -1, pagename: "New Purchase Order", indentid: '' }}
                        className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-primary ${this.state.hovered === "new" ? 'UI-btn-primary-hover' : ''}`}
                        style={{ textDecoration: "none" }}
                        onMouseEnter={() => this.setState({ hovered: "new" })}
                        onMouseLeave={() => this.setState({ hovered: null })}
                      >
                        <i className="fa fa-plus" /> {isMobile ? "New" : "New Purchase"}
                      </Link>
                    )}
                  </div>
                </div>
              </div>

              {this.state.loading ? (
                <div className="UI-loading-container">
                  {spin}
                </div>
              ) : (
                <div style={{ marginTop: '8px' }}>
                  {this.state.currentView === 'list'
                    ? this.renderListView()
                    : this.renderDetailView()
                  }
                </div>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div >
    );
  }
}

export default withRouter(Purchase);